import { useEffect } from 'react'

import { useAppContext } from '@/app/index.context'
import csiFavicon from '@/assets/img/csi/favicon.ico'
import elkjopFavicon from '@/assets/img/elkjop/favicon.png'
import iceFavicon from '@/assets/img/ice/ice_favicon.png'
import komplettFavicon from '@/assets/img/komplett/komplett-logo-favicon.png'
import mobitFavicon from '@/assets/img/mobit/favicon.png'
import skytechFavicon from '@/assets/img/skytech/favicon-black.png'
import teliaFavicon from '@/assets/img/telia/telia_logo.svg'
import threeStepITFavicon from '@/assets/img/threeStepIT/threeStepITLogo.svg'
import tietoEvryFavicon from '@/assets/img/tieto-evry/tietoevry_favicon.png'
import { getAppName } from '@/util/getAppName'

const MetaTags = () => {
  const { whiteLabel } = useAppContext()
  const appName = getAppName(whiteLabel)

  useEffect(() => {
    refreshMeta()
  })

  const refreshMeta = () => {
    setDocTitle(appName)

    switch (whiteLabel) {
      case 'ice':
        setDocFavicon(iceFavicon)
        break
      case 'tietoevry':
        setDocFavicon(tietoEvryFavicon)
        break
      case 'elkjop':
        setDocFavicon(elkjopFavicon)
        break
      case 'telia':
        setDocFavicon(teliaFavicon)
        break
      case 'mobit':
        setDocFavicon(mobitFavicon)
        break
      case 'csi':
        setDocFavicon(csiFavicon)
        break
      case 'threeStepIT':
        setDocFavicon(threeStepITFavicon)
        break
      case 'komplett':
        setDocFavicon(komplettFavicon)
        break
      default:
        setDocFavicon(skytechFavicon)
    }
  }

  const setDocTitle = (title: string) => {
    document.title = title
  }

  const setDocFavicon = (file: string) => {
    const favicon = document.querySelector("link[rel*='icon']") as HTMLAnchorElement
    favicon.href = file
  }

  return null
}

export default MetaTags
